<template>
<section>

    <!-- Main navbar -->
    <top-menu></top-menu>

    <!-- Page content -->
    <div class="page-content">
        <!-- Main sidebar -->
        <left-menu></left-menu>
        <div class="content-wrapper">
            <slot />
        </div>
    </div>
    <!-- /page content -->
</section>
</template>

<script>
import TopMenu from './admin/TopMenu'
import LeftMenu from './admin/LeftMenu'

export default {
    name: "AdminLayout",
    components: {
        TopMenu,
        LeftMenu
    },
    watch: {
        '$route'(newRoute) {
            this.showTitle();
        },
    },
    methods: {
        showTitle() {
            let suffix = this.$route.meta.suffix;
            if (suffix === undefined) {
                suffix = ''
            } else {
                suffix = ' ' + this.$t(suffix);
            }
            document.title = this.$t(this.$route.meta.title) + suffix;
        },
    },
    mounted() {
        this.showTitle();
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/central/AdminLayout.vue